import { getDataType } from './tool';

let globle = {
  req: process.env.VUE_APP_BASE_API,
  caseAssetUrl: process.env.VUE_APP_CASE_ASSET_URL,
  url: ''
};

// 过滤数据
Object.keys(globle).forEach(item => {
  let type = getDataType(globle[item]);

  if (type === 'object' || type === 'array') {
    window[item] = JSON.parse(JSON.stringify(globle[item]));
  } else {
    window[item] = globle[item];
  }
});
